module.exports = __webpack_public_path__ + "images/bdf30fe.jpg";